<template>
  <Tabs v-model="tabName" @on-click="changeTab">
    <TabPane label="话务概览" name="callOverview">
      <div class="standard_home_page" :style="screenHeight">
        <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
        <div class="top_area">
          <div class="top_left">
            <el-tabs v-model="topLeft" @tab-click="handleTopLeftClick">
              <el-tab-pane name="0" disabled>
                <span slot="label">话务分析</span>
                <el-tooltip slot="label" effect="light" placement="right">
                  <div slot="content">
                    呼入总量：客户呼入数量（如客户呼入只到IVR也算，但需要确认这个热线号码是在呼叫中心上所配置的）<br/>
                    转人工量：统计只要进了技能组的电话数就算转人工，针对呼入及自动呼出的数据<br/>
                    转人工接通量：客户与座席接通的数量，针对客户呼入、自动呼出的数据 <br/>
                    呼入接通率：呼入接通量/呼入总量<br/>
                    呼出总量：手动呼出及自动呼出数量<br/>
                    呼出接通量：客户接通的数量，针对手动呼出、自动呼出的数据<br/>
                    呼出接通率：呼出接通量/呼出量<br/>
                    转满意度量：转满意度的数量，针对客户呼入、手动呼出、自动呼出的数据<br/>
                    好评率：(非常满意+满意)/转满意度量<br/>
                    平均通话时长：客户与座席的通话时长/(转人工接通量+手动呼出接通量)<br/>
                    平均排队时长：(座席接听时间点-客户进技能组时间点)/转人工接通量。
                  </div>
                  <img :src="questionMark"/>
                </el-tooltip>
                <div slot="label" class="img_home" title="全局刷新"><img class="refresh" :src="refresh" @click="initSearch"/></div>
              </el-tab-pane>
              <el-tab-pane label="月" name="3"></el-tab-pane>
              <el-tab-pane label="周" name="2"></el-tab-pane>
              <el-tab-pane label="日" name="1"></el-tab-pane>
            </el-tabs>
            <div class="picture_style" :style="tableHeight">
              <div class="left">
                <div class="topLeft_left">
                  <div style="width: 60%">呼入总量</div>
                  <div style="width: 20%;color: #2c92ba">{{callinCount}}</div>
                  <div style="width: 20%">通</div>
                </div>
                <div class="topLeft_right">
                  <div style="width: 60%">呼出接通量</div>
                  <div style="width: 20%;color: #ef914b">{{calloutAnswer}}</div>
                  <div style="width: 20%">通</div>
                </div>
                <div class="topLeft_left">
                  <div style="width: 60%">呼出总量</div>
                  <div style="width: 20%;color: #2c92ba">{{calloutCount}}</div>
                  <div style="width: 20%">通</div>
                </div>
                <div class="topLeft_right">
                  <div style="width: 60%">转人工接通量</div>
                  <div style="width: 20%;color: #ef914b">{{turnPeopleAnswer}}</div>
                  <div style="width: 20%">通</div>
                </div>
                <div class="topLeft_left">
                  <div style="width: 60%">转人工量</div>
                  <div style="width: 20%;color: #2c92ba">{{turnPeople}}</div>
                  <div style="width: 20%">通</div>
                </div>
                <div class="topLeft_right">
                  <div style="width: 60%">平均通话时长</div>
                  <div style="width: 20%;color: #ef914b">{{callDurationAverage}}</div>
                  <div style="width: 20%">秒</div>
                </div>
                <div class="topLeft_left">
                  <div style="width: 60%">转满意度</div>
                  <div style="width: 20%;color: #2c92ba">{{turnSatisfied}}</div>
                  <div style="width: 20%">通</div>
                </div>
                <div class="topLeft_right">
                  <div style="width: 60%">平均排队时长</div>
                  <div style="width: 20%;color: #ef914b">{{lineUpAverage}}</div>
                  <div style="width: 20%">秒</div>
                </div>
              </div>
              <div class="right" style="overflow:hidden">
                <div id="customerHomeTotal" class="customer_total" style="width: 100%;height: 56%;"></div>
                <div id="callInTotal" class="customer_total" style="width: 45%;height: 44%;float: left;"></div>
                <div id="callOutTotal" class="customer_total" style="width: 45%;height: 44%;float: right;"></div>
              </div>
            </div>
          </div>
          <div class="top_right">
            <el-tabs v-model="topRight" @tab-click="handleTopRightClick">
              <el-tab-pane name="0" disabled>
                <span slot="label">客户类型统计</span>
                <el-tooltip slot="label" effect="light"  content="客户类型:自定义设置==>客户模块==>编辑客户类型" placement="right"><img :src="questionMark"/></el-tooltip>
              </el-tab-pane>
            </el-tabs>
            <div class="picture_style" :style="tableHeight">
              <div id="customerTypeTotal" class="customer_total" style="width: 97%;height: 100%;"></div>
            </div>
          </div>
        </div>
        <div class="bottom_area">
          <div class="bottom_left">
            <el-tabs v-model="bottomLeft" @tab-click="handleBottomLeftClick">
              <el-tab-pane name="0" disabled>
                <span slot="label">TOP10座席话务</span>
                <el-tooltip slot="label" effect="light" placement="right">
                  <div slot="content">
                    呼入接通量：客户呼入分配到该座席接通的数量<br/>
                    呼出接通量：该座席与客户通话的数量，包含手动呼出的数量+自动呼出
                  </div>
                  <img :src="questionMark"/>
                </el-tooltip>
              </el-tab-pane>
              <el-tab-pane label="月" name="3"></el-tab-pane>
              <el-tab-pane label="周" name="2"></el-tab-pane>
              <el-tab-pane label="日" name="1"></el-tab-pane>
            </el-tabs>
            <div class="picture_style" :style="tableHeight">
              <div id="showEmpMessage" class="customer_total" style="width: 98%;height: 100%;"></div>
            </div>
          </div>
          <div class="bottom_right">
            <el-tabs v-model="bottomRight" @tab-click="handleBottomRightClick">
              <el-tab-pane name="0" disabled>
                <span slot="label">通话趋势</span>
                <el-tooltip slot="label" effect="light" placement="right">
                  <div slot="content">
                    呼入总量：客户呼入数量（如客户呼入只到IVR也算，但需要确认这个热线号码是在呼叫中心上所配置的)<br/>
                    呼出总量：手动呼出及自动呼出数量<br/>
                    呼入接通量：客户呼入分配到该座席接通的数量<br/>
                    呼出接通量：该座席与客户通话的数量，包含手动呼出的数量+自动呼出
                  </div>
                  <img :src="questionMark"/>
                </el-tooltip>
              </el-tab-pane>
              <el-tab-pane label="月" name="3"></el-tab-pane>
              <el-tab-pane label="周" name="2"></el-tab-pane>
              <el-tab-pane label="日" name="1"></el-tab-pane>
            </el-tabs>
            <div class="picture_style" :style="tableHeight">
              <div id="showPhoneTrendTotal" class="customer_total" style="width: 98%;height: 100%;"></div>
            </div>
          </div>
        </div>
      </div>
    </TabPane>
    <TabPane label="工单概览" name="workOrderOverview" v-if="sysSupportWorkOrder=='1'">
        <WorkOrderOverview :tabName="tabName" @orderClick="orderClick"></WorkOrderOverview>
    </TabPane>
  </Tabs>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import WorkOrderOverview from '@/components/login/WorkOrderOverview.vue';
    export default {
        name: "StandardSysHomePage",
        mixins:[publicFunClass],
        components: {
           WorkOrderOverview
        },
        data(){
          return{
            tabName:"callOverview",
            sysSupportWorkOrder: JSON.parse(localStorage.getItem("sysSupportWorkOrder")),

            callinAnswerAverage:0,
            calloutAnswerAverage:0,
            callinCount:"0",
            calloutAnswer:"0",
            calloutCount:"0",
            turnPeopleAnswer:"0",
            turnPeople:"0",
            callDurationAverage:"0",
            turnSatisfied:"0",
            lineUpAverage:"0",
            topLeft:'1',
            topRight:'1',
            bottomLeft:'1',
            bottomRight:'1',
            questionMark:require('../../assets/image/homeAsk.png'),
            refresh:require('../../assets/image/refresh.png'),
            spinShow: false,
            screenHeight:{height:''},
            tableHeight:{height:''},
            chartWidth:{width:'100%',height:''},
            showEmpMessage:null,
            xLabel: '',
          }
        },
        methods: {
          changeTab:function(tabName){
            this.tabName = tabName;
          },


          handleTopLeftClick:function () {
            let callInTotal = this.$echarts.init(document.getElementById('callInTotal'));
            let callOutTotal = this.$echarts.init(document.getElementById('callOutTotal'));
            let customerTotal = this.$echarts.init(document.getElementById('customerHomeTotal'));
            let that=this;
            let param={
              journalType:"null",
              menuId:"null",
              createTime:this.getSearchTime(this.topLeft)
            };
            this.$http.post("home/callAllCount.json",param) .then(function (res) {//查询话务统计
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              let list=res.data.obj.list;
              that.callinCount="0";
              that.calloutAnswer="0";
              that.calloutCount="0";
              that.turnPeopleAnswer="0";
              that.turnPeople="0";
              that.callDurationAverage="0";
              that.turnSatisfied="0";
              that.lineUpAverage="0";
              that.callinAnswerAverage=0;
              that.calloutAnswerAverage=0;
              if(list && list.length>0){
                that.callinCount=list[0].callinCount;
                that.calloutAnswer=list[0].calloutAnswer;
                that.calloutCount=list[0].calloutCount;
                that.turnPeopleAnswer=list[0].turnPeopleAnswer;
                that.turnPeople=list[0].turnPeople;
                that.callDurationAverage=list[0].callDurationAverage;
                that.turnSatisfied=list[0].turnSatisfied;
                that.lineUpAverage=list[0].lineUpAverage;
                that.callinAnswerAverage=parseInt(list[0].callinAnswerAverage);
                that.calloutAnswerAverage=parseInt(list[0].calloutAnswerAverage);
              }
              callInTotal.setOption({
                tooltip: {
                  trigger: 'item',
                  formatter: '{b}: {c}%'
                },
                color:['#88cddc'],
                graphic:{
                  type:"text",
                  left:"center",
                  top:"center",
                  cursor:'default',
                  style:{
                    text:that.callinAnswerAverage+"%\n\n呼入\n接通率",
                    textAlign:"center",
                    fill:"#262829",
                    fontSize:13
                  }
                },
                series: [
                  {
                    name: '呼入接通率',
                    type: 'pie',
                    radius: ['75%', '80%'],
                    label: {
                      show: false,
                      position: 'left'
                    },
                    data: [
                      {value: that.callinAnswerAverage, name: '呼入接通率'}
                    ]
                  }
                ]
              });
              window.addEventListener('resize', () => {
                if(this){
                  callInTotal.resize()
                }
              })
              callOutTotal.setOption({
                tooltip: {
                  trigger: 'item',
                  formatter: '{b}: {c}%'
                },
                color:['#99c97d'],
                graphic:{
                  type:"text",
                  left:"center",
                  top:"center",
                  cursor:'default',
                  style:{
                    text:that.calloutAnswerAverage+"%\n\n呼出\n接通率",
                    textAlign:"center",
                    fill:"#262829",
                    fontSize:13
                  }
                },
                series: [
                  {
                    name: '呼出接通率',
                    type: 'pie',
                    radius: ['75%', '80%'],
                    label: {
                      show: false,
                      position: 'right'
                    },
                    data: [
                      {value: that.calloutAnswerAverage, name: '呼出接通率'}
                    ]
                  }
                ]
              });

              window.addEventListener('resize', () => {
                if(this) {
                  callOutTotal.resize()
                }
              })
            });
            this.$http.post("home/callGradeCount.json",param) .then(function (res) {//查询话务满意度
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              let satisfiedList=[{'name':'非常满意','value':'0'},{'name':'满意','value':'0'},{'name':'一般','value':'0'},{'name':'服务态度不满意','value':'0'},{'name':'处理结果不满意','value':'0'}];
              let list=res.data.obj.list;
              if(list && list.length>0){
                satisfiedList=[];
                let param={
                  name:"非常满意",
                  value:list[0].verySatisfied
                };
                let param1={
                  name:"满意",
                  value:list[0].satisfied
                };
                let param2={
                  name:"一般",
                  value:list[0].commonlyGrade
                };
                let param3={
                  name:"服务态度不满意",
                  value:list[0].notGradeService
                };
                let param4={
                  name:"处理结果不满意",
                  value:list[0].notGradeResult
                };
                satisfiedList.push(param);
                satisfiedList.push(param1);
                satisfiedList.push(param2);
                satisfiedList.push(param3);
                satisfiedList.push(param4);
              }
              customerTotal.setOption({
                tooltip: {
                  trigger: 'item',
                  formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                title:[{
                  text:"满意度\n统计",
                  textAlign:"center",
                  x:"center",
                  y:"center",
                  left:"70%",
                  textStyle: {
                    fontSize: 13 ,
                    color: '#858585' ,
                  },
                }],
                legend: {
                  orient: 'vertical',
                  left:2,
                  itemHeight:10,
                  itemGap: 8 ,
                  textStyle: {
                      fontSize: 12 ,
                  },
                  data: ['非常满意', '满意', '一般','服务态度不满意', '处理结果不满意']
                },
                color : [ '#add597', '#79c6d8', '#1e7ca0', '#dbdd00', '#f19049'],
                series: [
                  {
                    name: '满意度统计',
                    type: 'pie',
                    radius: ['50%', '83%'],
                    center: ['70%', '50%'] ,
                    hoverOffset:8,
                    avoidLabelOverlap: false,
                    label: {
                      show: false,
                      position: 'left',
                      normal: {
                        show: true,
                        formatter: '{c}',
                        position: 'inside'
                      }
                    },
                    emphasis: {
                      label: {
                        show: true,
                        fontSize: '20',
                        fontWeight: 'bold'
                      }
                    },
                    labelLine: {
                      show: false
                    },
                    data:satisfiedList
                  }
                ]
              });
              window.addEventListener('resize', () => {
                if(this){
                  customerTotal.resize()
                }
              })
            });
          },
          handleTopRightClick:function () {
            let customerTypeTotal = this.$echarts.init(document.getElementById('customerTypeTotal'));
            let that=this;
            let param={
              journalType:"null",
              menuId:"null",
            };
            this.$http.post("home/customerCount.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              let customerTypeList=[];let customerTypeCount=[];
              let list=res.data.obj;
              if(list){
                for (let key in list) {
                  let param={
                    name:key,
                    value:list[key]
                  };
                  customerTypeList.push(key);
                  customerTypeCount.push(param);
                }
              }
              customerTypeTotal.setOption({
                legend: {
                  data: ['客户类型统计']
                },
                xAxis: {
                  data: customerTypeList,
                  axisLabel: {
                    interval:0,
                  }
                },
                yAxis: [{}],
                series: [{
                  itemStyle: {
                    normal: {
                      label: {
                        show: true, //开启显示
                        position: 'top',
                        textStyle: { //数值样式
                          color: 'black',
                          fontSize: 14
                        }
                      }
                    }
                  },
                  name: '客户总量',
                  type: 'bar',
                  barMaxWidth: 25, // 最大宽度
                  data: customerTypeCount,
                  color: '#79c6da'
                }]
              });
            });
          },
          handleBottomLeftClick:function () {
            let that=this;
            let param={
              journalType:"null",
              menuId:"null",
              showCount:'10',
              createTime:this.getSearchTime(this.bottomLeft)
            };
            this.$http.post("home/callAgentCount.json",param) .then(function (res) {
              let result = res.data.flag;
              if (result != "666") {
                that.$Modal.info({
                  title: '提示',
                  content: res.data.msg
                });
                return false;
              }
              let columnarXData=[];
              let XData=[];
              let YData=[];
              let contentList=res.data.obj.list;
              if(contentList && contentList.length>0){
                let sumSuccessLegIn=0;
                let sumSuccessLegOut=0;
                for(let i=0;i<contentList.length;i++){
                  sumSuccessLegOut=sumSuccessLegOut+parseInt(contentList[i].calloutAnswer);
                  sumSuccessLegIn=sumSuccessLegIn+parseInt(contentList[i].callinAnswer);
                  XData.push(parseInt(contentList[i].callinAnswer));
                  YData.push(parseInt(contentList[i].calloutAnswer));
                  columnarXData.push(contentList[i].agentname);
                }
              }
              that.showEmpMessage = that.$echarts.init(document.getElementById('showEmpMessage'));
              that.showEmpMessage.on('mouseover',that.xAxisOver);
              that.showEmpMessage.on('mouseout',that.xAxisout);


              that.showEmpMessage.setOption({
                tooltip: {
                  function(params) {
                      return this.xLabel
                  }
                },
                legend: {
                  data: ['呼入接通量', '呼出接通量'],
                },
                xAxis: {
                  data: columnarXData,
                  triggerEvent: true,
                  axisLabel: {
                    interval:0,
                    rotate:45, //代表逆时针旋转45度
                    formatter: function(value) {
                        if (value.length > 4) {
                        return value.substring(0, 4) + "...";
                        } else {
                        return value;
                        }
                    }
                  }
                },
                yAxis: [{
                  minInterval: 1
                }],
                series: [{
                  name: '呼入接通量',
                  type: 'bar',
                  barMaxWidth: 25, // 最大宽度
                  data: XData,
                  color: '#79c6d8'
                },
                  {
                    name: '呼出接通量',
                    type: 'bar',
                    barMaxWidth: 25, // 最大宽度
                    data: YData,
                    color: '#fddca9'
                  }]
              });


            });
          },
          formateTooltip (params) {
            return this.xLabel
          },
          xAxisOver (params) {
              if (params.componentType === 'xAxis') {
                this.xLabel = params.value
                let offsetX = params.event.offsetX + 10
                let offsetY = params.event.offsetY + 10
                this.showEmpMessage.setOption({tooltip: {
                  formatter: this.formateTooltip,
                  alwaysShowContent: true
                }})
                this.showEmpMessage.dispatchAction({
                  type: 'showTip',
                  seriesIndex: 0,
                  dataIndex: 0,
                  position: [offsetX, offsetY]
                })
              }
          },
          xAxisout (params) {
              if (params.componentType === 'xAxis') {
                this.xLabel = ''
                this.showEmpMessage.setOption({tooltip: {
                  formatter: this.formateTooltip,
                  alwaysShowContent: false
                }})
              }
          },

          handleBottomRightClick:function () {
            let that=this;
            this.spinShow=false;
            let showPhoneTrendTotal = this.$echarts.init(document.getElementById('showPhoneTrendTotal'));
            let param={
              journalType:"null",
              menuId:"null",
              createTime:this.getSearchTime(this.bottomRight),
              formType:this.bottomRight
            };
            this.$http.post("home/callAllReport.json",param) .then(function (res) {
              let result = res.data.flag;
              if (result != "666") {
                that.$Modal.info({
                  title: '提示',
                  content: res.data.msg
                });
                return false;
              }
              let list=res.data.obj.list;
              let lineXData=[];
              let YData1=[];
              let YData2=[];
              let YData3=[];
              let YData4=[];
              if(list && list.length>0){
                for(let i=0;i<list.length;i++){
                  if(that.bottomRight=='1'){
                    lineXData.push(list[i].date2);
                  }
                  if(that.bottomRight=='2' || that.bottomRight=='3'){
                    lineXData.push(list[i].date1);
                  }
                  YData1.push(list[i].callinCount);
                  YData2.push(list[i].calloutCount);
                  YData3.push(list[i].callinAnswer);
                  YData4.push(list[i].calloutAnswer);
                }
              }
              showPhoneTrendTotal.setOption({
                tooltip: {
                  trigger: 'axis'
                },
                legend: {
                  data: ['呼入量', '呼出量', '呼入接通量', '呼出接通量']
                },
                calculable: true,
                xAxis: [
                  {
                    type: 'category',
                    data: lineXData
                  }
                ],
                yAxis: [
                  {
                    type: 'value'
                  }
                ],
                series: [
                  {
                    name: '呼入量',
                    type: 'line',
                    data: YData1,
                    color: '#91a1a5'
                  },
                  {
                    name: '呼出量',
                    type: 'line',
                    data:  YData2,
                    color: '#ffc8a5'
                  },
                  {
                    name: '呼入接通量',
                    type: 'line',
                    data:  YData3,
                    color: '#daceab'
                  },
                  {
                    name: '呼出接通量',
                    type: 'line',
                    data: YData4,
                    color: '#f58e2e'
                  }
                ]
              });
            });
          },
          initSearch:function () {
            this.spinShow=true;
            this.handleTopLeftClick();
            this.handleTopRightClick();
            this.handleBottomLeftClick();
            this.handleBottomRightClick();
          },
          // 工单点击
          orderClick:function(val){
            this.$emit("showStandardPage",val,[]);
          }
        },
       created(){
         this.screenHeight.height=this.mountHeight(145);
         let clientHeight=document.documentElement.clientHeight-145;
         this.tableHeight.height=(clientHeight*0.48-50)+'px';
        },
        mounted () {
          this.initSearch();
        },
        watch:{
          tabName:function(){
            if(this.tabName == 'callOverview'){
              this.initSearch();
            }
          }
        }
    }
</script>

<style  lang="less">
  .demo-split{
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }
  .week{
    color: #52d00b;
    border-bottom: 4px solid #52d00b;
  }
  .day{
    color: #52d00b;
    border-bottom: 4px solid #52d00b;
  }
  .month{
    color: #52d00b;
    border-bottom: 4px solid #52d00b;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/StandardSysHomePage.vue